import React from "react";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Paper from "@mui/material/Paper";
import Draggable from "react-draggable";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
// import deleteClase from "../../services/Clases/deleteClase";
import deleteTabla from "../Services/deleteTabla";
import { useDispatch } from "react-redux";
import {
  addDataTitle,
  addDataDinamic,
} from "../../redux/reducers/TableroEncuestas/TableroEncuestasSlices";

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

export default function DialogoConfimacion({
  id,
  setIdHeaders,
  setId,
  setSettings,
  useStatus,
  setData,
}) {
  const [open, setOpen] = React.useState(false);

  const [fullWidth] = React.useState(true);
  const [maxWidth] = React.useState("sm");

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // Para evitar que cuando le den en eliminar entrar al rowclick
  const handleActionColmunClick = (event) => {
    event.stopPropagation();
  };

  const dispatch = useDispatch();

  // const dataTitle = useSelector((state) => state.tablaDinamicaEventos.titulo);

  const handleClick = () => {
    deleteTabla(id).then(() => {
      setIdHeaders(0);
      setId();
      dispatch(addDataTitle([]));
      setSettings({});
      dispatch(addDataDinamic([]));
      useStatus(false);
      setData([]);
    });
    handleClose();
  };

  return (
    <div onClick={handleActionColmunClick}>
      <IconButton size="small" onClick={handleClickOpen} aria-label="delete">
        <DeleteIcon fontSize="small" />
      </IconButton>
      <Dialog
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={open}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          Confirmación
        </DialogTitle>
        <DialogContent>
          <DialogContentText>Eliminar la tabla ?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={handleClose}
            //  color="default"
            variant="contained"
          >
            Cancelar
          </Button>

          <Button
            autoFocus
            onClick={handleClick}
            // color="primary"
            variant="contained"
          >
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
